import { useContext, useState, FC, useEffect } from 'react'

import { ProfessionalContractType, ProfessionalContractTypeFilterKeyString } from 'InstitutionalManagement/types'
import { PROFESSIONAL_CONTRACT_TYPE_INITIAL_FILTER } from 'InstitutionalManagement/constants/pages/professionalContractTypes'
import CustomFormProfessionalContractTypeSelectionDrawerManagerContext from './Context'
import readProfessionalContractTypesOnCustomForm from './services/readProfessionalContractTypesOnCustomForm'

type Props = {
  questionKey: string
  children: JSX.Element
}

const CustomFormProfessionalContractTypeSelectionDrawerManagerProvider: FC<Props> = ({ questionKey, children }) => {
  const [view, setView] = useState<string>('SEARCH_PROFESSIONAL_CONTRACT_TYPE')
  const [selectedProfessionalContractType, setSelectedProfessionalContractType] = useState<ProfessionalContractType>({})
  const [loadingProfessionalContractTypes, setLoadingProfessionalContractTypes] = useState<boolean>(true)
  const [professionalContractTypes, setProfessionalContractTypes] = useState<ProfessionalContractType[]>([])
  const [filter, setFilter] = useState<ProfessionalContractTypeFilterKeyString>(
    PROFESSIONAL_CONTRACT_TYPE_INITIAL_FILTER
  )

  async function loadProfessionalContractType() {
    setLoadingProfessionalContractTypes(true)
    const filters = {
      filter,
      pagination: {
        page: 1,
        limit: 0,
      },
    }

    const response = await readProfessionalContractTypesOnCustomForm({ filters })

    if (response?.header?.success) {
      const professionalContractTypesFromAPI = response?.body?.contract_type?.elements
      setProfessionalContractTypes(professionalContractTypesFromAPI || [])
    }
    setLoadingProfessionalContractTypes(false)
  }

  useEffect(() => {
    if (view != 'SEARCH_PROFESSIONAL_CONTRACT_TYPE') loadProfessionalContractType()
  }, [filter])

  return (
    <CustomFormProfessionalContractTypeSelectionDrawerManagerContext.Provider
      value={{
        view,
        setView,
        selectedProfessionalContractType,
        setSelectedProfessionalContractType,
        filter,
        setFilter,
        questionKey,
        professionalContractTypes,
        loadingProfessionalContractTypes,
        setLoadingProfessionalContractTypes,
      }}
    >
      {children}
    </CustomFormProfessionalContractTypeSelectionDrawerManagerContext.Provider>
  )
}

export const useCustomFormProfessionalContractTypeSelectionDrawerManager = () =>
  useContext(CustomFormProfessionalContractTypeSelectionDrawerManagerContext)

export default CustomFormProfessionalContractTypeSelectionDrawerManagerProvider
